<script setup lang="ts">
import { SHARED_ANCHORS } from '@/modules/onboarding/scenarios/shared/anchors'

/**
 * Ушко правой панели embedded-формы сущности с подписью («Задача» / «Чат»).
 * Открытая панель подсвечивается цветом secondary; что делает клик (показать/скрыть панель) — решает форма.
 */
const props = withDefaults(defineProps<{
  kind: 'tasks' | 'chat'
  active?: boolean
}>(), {
  active: false,
})

const emit = defineEmits<{
  click: []
}>()

const EARS = {
  tasks: { icon: 'ri-list-check', label: 'Задача' },
  chat: { icon: 'ri-chat-1-line', label: 'Чат' },
} as const

const ear = computed(() => EARS[props.kind])
</script>

<template>
  <VBtn
    :prepend-icon="ear.icon"
    :color="active ? 'secondary' : 'primary'"
    class="entity-form-action-btn entity-form-action-btn--labeled"
    :data-onboarding="SHARED_ANCHORS.ear[kind]"
    @click.stop="emit('click')"
  >
    {{ ear.label }}
  </VBtn>
</template>
